const BLOCKED_TAGS = new Set([
  'script', 'iframe', 'object', 'embed', 'applet', 'meta', 'link', 'base',
  'form', 'svg', 'math', 'frame', 'frameset', 'noscript',
]);
const URL_ATTRS = new Set(['href', 'src', 'xlink:href', 'action', 'formaction', 'data', 'srcset']);

const isDangerousUrl = (value) => {
  // eslint-disable-next-line no-control-regex
  const v = String(value).replace(/[\u0000-  ]+/g, '').toLowerCase();
  // eslint-disable-next-line no-script-url
  return v.startsWith('javascript:') || v.startsWith('vbscript:') ||
    (v.startsWith('data:') && !v.startsWith('data:image/'));
};

/**
 * Removes executable content (scripts, event handlers, javascript: URLs, active embeds) from
 * stored HTML before it is rendered with dangerouslySetInnerHTML. Formatting is left untouched.
 */
export function sanitizeHtml(html) {
  if (html === null || html === undefined) return '';
  const input = String(html);
  if (!input || typeof DOMParser === 'undefined') return input ? escapeText(input) : '';

  const doc = new DOMParser().parseFromString(`<body>${input}</body>`, 'text/html');
  const walk = (node) => {
    Array.from(node.children).forEach((el) => {
      if (BLOCKED_TAGS.has(el.tagName.toLowerCase())) {
        el.remove();
        return;
      }
      Array.from(el.attributes).forEach((attr) => {
        const name = attr.name.toLowerCase();
        if (name.startsWith('on')) {
          el.removeAttribute(attr.name);
        } else if (URL_ATTRS.has(name) && isDangerousUrl(attr.value)) {
          el.removeAttribute(attr.name);
        } else if (name === 'style' && /expression\s*\(|javascript:|url\s*\(\s*['"]?\s*javascript:/i.test(attr.value)) {
          el.removeAttribute(attr.name);
        }
      });
      walk(el);
    });
  };
  walk(doc.body);
  return doc.body.innerHTML;
}

function escapeText(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export default sanitizeHtml;
